import { useEffect, useState, memo } from 'react';

import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/slw/shared/ui/input-otp';
import { cn } from '@/slw/shared/lib/utils';
import { useDebounce } from '@/slw/shared/hooks/use-debounce';

const OtpStepComponent = ({
  onSubmit,
  error,
  onResend,
  resendCooldown,
  setError,
}: {
  onSubmit: (otp: string) => void;
  setError: (error: string) => void;
  error?: string;
  onResend: () => void;
  resendCooldown: number;
}) => {
  const [value, setValue] = useState('');
  const debouncedValue = useDebounce(value, 500);

  useEffect(() => {
    if (debouncedValue.length === 6) {
      onSubmit(debouncedValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  useEffect(() => {
    if (error) {
      setValue('');
      setError('');
    }
  }, [error, setError]);

  const handleResend = () => {
    setValue('');
    onResend();
  };

  return (
    <div className='flex flex-col w-full '>
      <p className='text-sm font-medium mb-2'>Keep this window open and check your email</p>
      <p className='text-sm'>
        We sent a 6 digit code to your email address. Verify your account by pasting the code below.
      </p>
      <p className='text-sm'>Be sure to check your Spam folder.</p>
      <div className='flex flex-col items-center w-full mb-2 mt-4'>
        <InputOTP maxLength={6} value={value} onChange={setValue}>
          <InputOTPGroup className='gap-x-2'>
            {[...Array(6)].map((_, i) => (
              <InputOTPSlot
                key={i}
                index={i}
                className={cn(
                  'w-13 h-13 !rounded-lg text-lg font-bold border border-[#e5e7eb] bg-white text-center',
                  'focus:!border-[#c8a978] data-[active=true]:border-[#c8a978] focus:outline-none transition',
                )}
              />
            ))}
          </InputOTPGroup>
        </InputOTP>
      </div>
      <div className='flex flex-col items-center w-full mb-2'>
        <div className='flex items-center gap-1 text-sm w-full'>
          <span>Didn&apos;t get the email?</span>
          <button
            type='button'
            className='text-[#22c55e] font-semibold disabled:opacity-50 cursor-pointer'
            onClick={handleResend}
            disabled={resendCooldown > 0}
          >
            Resend Code{resendCooldown ? ` (${resendCooldown})` : ''}
          </button>
        </div>
        {/* {error && <div className='text-sm text-[#dc2626] mt-2'>{error}</div>} */}
      </div>
      <p></p>
      <div className='text-sm  mb-1 w-full text-left'>
        If you still need help, email us at{' '}
        <a href='mailto:support@ClovisClassics.com' className='text-[#c8a978] hover:underline'>
          support@ClovisClassics.com
        </a>
      </div>
    </div>
  );
};

export const OtpStep = memo(OtpStepComponent);
